import React, { useState } from 'react';
import { Box, Button, CircularProgress, Divider, Grid, IconButton, Modal, Paper, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import FileUpload from '../../../components/FileUpload';
import { apiClient } from '../../../utils/axios';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';

const DataExtractionButtonAction = ({ open, onCancel, document_type }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onFileUpload = (file) => {
    setFile(file);
  };

  const onSubmit = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('file', file);

    apiClient
      .post('/pdf-data-extractions', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status > 200 && response.status < 300) {
          dispatch(showSnackbar({ message: 'File upload successfully!', severity: 'success' }));
          onCancel();
        }
      })
      .catch((error) => {
        dispatch(
          showSnackbar({
            message: 'Error uploading the selected file. Please try again later',
            severity: 'error',
          }),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal open={open} onClose={onCancel}>
      <Paper
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          padding: 16,
          boxShadow: 24,
          outline: 'none',
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold">
            Upload Zip file for data extraction
          </Typography>
          <IconButton onClick={onCancel}>
            <Close />
          </IconButton>
        </Box>
        <Divider />
        <Grid sx={{ pt: 1 }}>
          <Typography variant="subtitle2" sx={{ py: 1 }}>
            Upload your file
          </Typography>
          <FileUpload onUpload={onFileUpload} supportedFormats={['.zip']} />
        </Grid>
        <Divider />
        <Grid mt={2} textAlign="right">
          <Button
            id="upload-start-processing"
            variant="contained"
            color="primary"
            disabled={!file || loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
            onClick={onSubmit}
          >
            {loading ? 'Processing...' : 'Upload & Start Processing'}
          </Button>
        </Grid>
      </Paper>
    </Modal>
  );
};

export default DataExtractionButtonAction;
